import { FC } from "react";
import { InvoiceEntryModeType } from "./service";
import { InvoiceEntryMode } from "./constants";

type InvoiceEntryModeToggleProps = {
  value: InvoiceEntryModeType;
  onChange: (mode: InvoiceEntryModeType) => void;
};

const OPTIONS: { label: string; value: InvoiceEntryModeType }[] = [
  { label: "Enter manually", value: InvoiceEntryMode.MANUAL },
  { label: "Upload in bulk", value: InvoiceEntryMode.BULK },
];

export const InvoiceEntryModeToggle: FC<InvoiceEntryModeToggleProps> = ({
  value,
  onChange,
}) => (
  <div className="cx-flex cx-flex-col sm:cx-flex-row sm:cx-items-center sm:cx-justify-between cx-gap-3 cx-pb-4 cx-border-b cx-border-gray-200">
    <h2 className="cx-text-base cx-font-medium cx-text-text-primary">
      How would you like to add invoices?
    </h2>
    <div className="cx-flex cx-items-center cx-gap-5 cx-shrink-0">
      {OPTIONS.map((option) => {
        const selected = value === option.value;
        return (
          <button
            key={option.value}
            type="button"
            className="cx-flex cx-items-center cx-gap-2 cx-text-sm cx-font-medium cx-text-text-primary"
            onClick={() => onChange(option.value)}
          >
            <span
              className={`cx-inline-flex cx-w-4 cx-h-4 cx-rounded-full cx-border cx-items-center cx-justify-center ${
                selected
                  ? "cx-border-[#0064FF] cx-bg-[#0064FF]"
                  : "cx-border-gray-300 cx-bg-white"
              }`}
            >
              {selected && (
                <span className="cx-w-1.5 cx-h-1.5 cx-rounded-full cx-bg-white" />
              )}
            </span>
            <span>{option.label}</span>
          </button>
        );
      })}
    </div>
  </div>
);
